
import axios from "../services/axios-config.js";


// FUNÇÃO DE BUSCA DAS SOLICITAÇÕES DE INTEGRAÇÃO COM O IFOOD
export const getIfoodRequests = async () => {
    return new Promise(async (resolve, reject) => {
        try {

            const res = await axios.get(`/admin/ifood/requests`);

            if (res.status == 200) {
                return resolve(res.data);
            }

        } catch (error) {
            console.error("ERROR - GET IFOOD REQUESTS FUNCTION:", error);
            reject(error);

        }

    })

};
